import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminEmails from "@/pages/admin/AdminEmails";

export const Route = createFileRoute("/admin/emails")({
  component: () => (
    <ProtectedRoute>
      <AdminEmails />
    </ProtectedRoute>
  ),
});
